import React from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import MainSidebar from "../../../Layout/MainSidebar";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import BrsrList from "./BrsrList";

const BRSRindex = () => {
  return (
    <MainDashboardLayout sidebar={<MainSidebar />}>
      <Unauthorized requiredModule="ESG Reporting | BRSR">
        <BrsrList />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default BRSRindex;
